import { render, staticRenderFns } from "./CheckoutConfirm.vue?vue&type=template&id=0cb2c49b&scoped=true&"
import script from "./CheckoutConfirm.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutConfirm.vue?vue&type=style&index=0&id=0cb2c49b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2c49b",
  null
  
)

export default component.exports